import { replaceYearString } from '@monoimin/atoms/utils/replaceYearString';

import { getUrlOrigin } from '@monoimin/utils/helpers';

import { HeadSchemaScript } from './HeadSchemaScript';

interface ArticleJsonLdProps {
  isInsider?: boolean;
  imageUrl?: string;
  datePublished?: string;
  dateModified?: string;
  description?: string;
  headline?: string;
  url?: string;
  authorName?: string;
  authorUrl?: string;
  publisherLogo?: string;
  publisherName?: string;
}
export const ArticleSchema = ({
  isInsider,
  imageUrl,
  authorUrl,
  authorName,
  publisherName,
  publisherLogo,
  description,
  headline,
  ...rest
}: ArticleJsonLdProps) => {
  const schema = {
    '@context': 'https://schema.org/',
    '@type': isInsider ? 'NewsArticle' : 'Article',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': rest.url,
      name: replaceYearString(headline),
    },
    copyrightHolder: {
      '@type': 'Organization',
      name: publisherName,
      url: getUrlOrigin(),
    },
    isPartOf: [
      {
        '@type': 'WebPage',
        '@id': rest.url,
        url: rest.url,
        name: replaceYearString(headline),
      },
    ],
    potentialAction: [
      {
        '@type': 'ReadAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: rest.url,
        },
      },
    ],
    copyrightYear: rest.datePublished,
    image: {
      '@type': 'ImageObject',
      url: imageUrl,
      width: 1920,
      height: 1080,
    },
    author: {
      '@type': 'Person',
      name: authorName,
      url: authorUrl,
    },
    description: replaceYearString(description),
    headline: replaceYearString(headline),

    ...rest,
  };

  const publisher =
    publisherName && publisherLogo
      ? {
          publisher: {
            '@type': 'Organization',
            name: publisherName,
            logo: {
              '@type': 'ImageObject',
              url: publisherLogo,
            },
          },
        }
      : {};

  return (
    <HeadSchemaScript
      id='add-article-jsonld'
      schemaId='article-jsonld'
      json={{ ...schema, ...publisher }}
    />
  );
};

export default ArticleSchema;
